import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import cn from 'classnames';

import styles from './styles.module.css';

class TileText extends PureComponent {
  render() {
    const { className, text, link, noFollow, primary, onClick } = this.props;

    return (
      <Link
        className={cn(
          primary ? styles.primaryText : styles.secondaryText,
          className,
        )}
        to={link}
        rel={noFollow ? 'nofollow' : undefined}
        onClick={onClick}
      >
        {text}
      </Link>
    );
  }
}

export default TileText;
